// The drawings on the "Open links" choices: the same three things in each (this computer on the
// left, the link above, the cloud machine on the right), and the arrow shows where the link goes.
// Colours are tokens (site-ui.css .link-art), so the drawing follows the theme.

import type { LinksSetting } from '../store';

export function LinkArt({ to }: { to: LinksSetting }) {
  const here = to === 'auto' || to === 'device';
  const there = to === 'auto' || to === 'machine';
  return (
    <svg className="link-art" width="136" height="60" viewBox="0 0 136 60" fill="none" aria-hidden="true" focusable="false">
      {/* the link */}
      <rect className="la-frame" x="50.5" y="0.5" width="35" height="13" rx="6.5" />
      <circle className="la-dot" cx="57.5" cy="7" r="2" />
      <path className="la-text" d="M63 7h16" />

      {/* this computer */}
      <g className={here ? undefined : 'la-dim'}>
        <rect className={here ? 'la-dest' : 'la-frame'} x="6.5" y="24.5" width="39" height="26" rx="3.5" />
        <path className="la-text" d="M12 32h18M12 37h12" />
        <rect className={here ? 'la-dest' : 'la-frame'} x="0.5" y="50.5" width="51" height="4" rx="2" />
      </g>

      {/* the cloud machine */}
      <g className={there ? undefined : 'la-dim'}>
        <rect className={there ? 'la-dest' : 'la-frame'} x="90.5" y="22.5" width="39" height="34" rx="3.5" />
        <path className="la-rule" d="M91 33.5h38M91 44.5h38" />
        <path className="la-text" d="M96 28h12M96 39h12M96 50h12" />
        <circle className="la-dot" cx="123" cy="28" r="1.5" />
        <circle className="la-led" cx="123" cy="39" r="1.5" />
        <circle className="la-led" cx="123" cy="50" r="1.5" />
      </g>

      {/* where it goes: out of the link's side, down onto the middle of the screen, 4 clear of both ends */}
      {here && <path className="la-arrow" d="M46.5 7C34 7 26 9 26 20.5M23 17.5l3 3 3-3" />}
      {there && <path className="la-arrow" d="M89.5 7C102 7 110 8 110 18.5M107 15.5l3 3 3-3" />}
    </svg>
  );
}
